export default __webpack_public_path__ + "static/media/151-transportation.fa20ec50.png";